import axios from '@/config/http';
import qs from 'qs';
import {
  initGetParams
} from '@/utils/index';



//获取新闻列表
export const getNews = (data) => axios.get(`/article/pagePortal?${initGetParams(data)}`);
//获取新闻数组列表
export const getNewsV = (data) => axios.post(`/article/pagePortalCode`, data);
//获取新闻详情
export const getNewsdetail = (data) => axios.get(`/article/detail?${initGetParams(data)}`);

//获取轮播图
export const getImages = (data) => axios.get(`/slideshow/pagePortal?${initGetParams(data)}`);

//获取科室列表
export const getSectionlist = (data) => axios.get(`/medicalSubjects/pagePortal?${initGetParams(data)}`);
//获取科室详情
export const getSection = (data) => axios.get(`/medicalSubjects/detail?${initGetParams(data)}`);

//获取专家列表
export const getSpecialistslist = (data) => axios.get(`/specialist/pagePortal?${initGetParams(data)}`);
//获取专家详情
export const getSectionDetail = (data) => axios.get(`/specialist/detail?${initGetParams(data)}`);

//获取领导班子
export const getLeadergroup = (data) => axios.get(`/specialist/leaderPagePortal?${initGetParams(data)}`);


//获取视频分页
export const getVideos = (data) => axios.get(`/video/pagePortal?${initGetParams(data)}`);
//获取视频详情
export const getVideos2 = (data) => axios.get(`/video/detail?${initGetParams(data)}`);

//获取留言分页
export const getmessage = (data) => axios.get(`/message/pagePortal?${initGetParams(data)}`);
//新增留言
export const postmessage = (data) => axios.post('/message/add', data);

//获取友情链接
export const getlists = (data) => axios.post(`/link/list`, data);